import { ColumnType, SpacingType, TableContextType, TableProps } from "../types";

/** Calculate the width on respect of the width defined in column setting */
export const calculateWidth = (width: number | undefined, spacingType: SpacingType) => {
    if (width === undefined) return undefined;
    let spacing = 0.75; // default padding for both side
    if (spacingType === 'comfortable') {
        spacing = 1;
    } else if (spacingType === 'compact') {
        spacing = 0.5;
    }
    return `calc(${width - 1}px - ${spacing * 2}rem)`; // removing 1px for border
}

export const deriveDefaultProps = (props: TableProps): TableContextType => {
    const {
        spacing = 'default',
        border = 'default',
        textAlign = 'left',
        page = 1,
        pageSize = 10,
        loading = false,
        totalRecords = 0,
        ...rest
    } = props;

    const paginationShouldActive = rest.showPagination && totalRecords > 0;

    return {
        ...rest,
        spacing,
        border,
        textAlign,
        page,
        pageSize,
        paginationShouldActive,
        loading,
        totalRecords
    }
}


export const warnings = (derivedProps: TableProps) => {

    const { showPagination, onPageChange, totalRecords,
        paginationRowInfoStart, paginationRowInfoEnd, columns, sortOrder, sortBy } = derivedProps

    // Validating all pagination required info
    if (showPagination === true) {
        if (totalRecords === undefined || onPageChange === undefined) {
            throw new Error("Table: totalRecords or onPageChange can not be undefined if you are using inbuilt pagination in the table")
        }
        if (paginationRowInfoStart === undefined || paginationRowInfoEnd === undefined) {
            console.error("Table: paginationRowInfoStart or paginationRowInfoEnd should be a number.")
        }
    }

    /**
     * If sortBy and sortOrder not present in right manner, like the sortBy value should ne one of the accessor from the 
     * column array. sortOrder value also should be in 'ascending', 'descending', 'none'
     */
    const sortByPresent = columns.find((item: ColumnType) => item.accessor === sortBy);
    const permissibleSortOrder = ['ascending', 'descending', 'none'];
    const sortOrderPresent = permissibleSortOrder.includes(sortOrder as string);

    if (sortBy && !sortByPresent) {
        throw new Error(`Table: sortBy ${sortBy} is not matching with any accessor in column config`);
    }

    if (sortOrder && !sortOrderPresent) {
        throw new Error(`Table: sortOrder value should be one of ${permissibleSortOrder.join(', ')}`);
    }
}

export const calculatePagination = (totalRecords: number, page = 1, pageSize = 10) => {
    const start = page == 1 ? 0 : ((page * pageSize) - pageSize);
    let end = page == 1 ? pageSize : page * pageSize;
    end = end > totalRecords ? totalRecords : end;
    return [start, end];
}

export function getFilterActionProps<T>(props: Partial<T>): T {
    return props as T;
}